import { Button, TextField, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Controller, ControllerRenderProps, useForm } from "react-hook-form";
import { useCreateUser } from "@src/entities/login/model/hooks/useCreateUser/useCreateUser";
import { textFieldStyles, submitButtonStyles, backButtonStyles } from "./theme";
import { reachGoal } from "@src/shared/lib/analytics/yandex/reachGoal";

import styles from "./styles.module.scss";
import { YM_GOALS } from "@src/shared/lib/analytics/yandex/constants";
interface RegistrationStep1Props {
  email: string;
}

interface Props {
  setStep: (step: number) => void;
  setRegistrationData: (data: any) => void;
}

export const RegistrationStep1 = ({ setStep, setRegistrationData }: Props) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { mutate: createUser, isPending } = useCreateUser();

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<RegistrationStep1Props>({
    defaultValues: {
      email: searchParams.get("login") || "",
    },
    mode: "onTouched",
  });

  const onSubmit = (data: RegistrationStep1Props) => {
    createUser(
      { login: data.email },
      {
        onSuccess: () => {
           reachGoal(YM_GOALS.REGISTRATION_STEP(1));
          setRegistrationData((prev: any) => ({ ...prev, email: data.email }));
          setStep(2);
        },
      }
    );
  };

  return (
    <>
      <div className={styles.formTitleContainer}>
        <Typography className={styles.formTitle}>Регистрация</Typography>
        <Typography className={styles.formTitle2}>Шаг 1</Typography>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
        <Controller
          name="email"
          control={control}
          rules={{
            required: "Поле обязательно для заполнения",
            pattern: {
              value: /^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/g,
              message: "Неверный формат email",
            },
          }}
          render={({
            field,
          }: {
            field: ControllerRenderProps<RegistrationStep1Props, "email">;
          }) => (
            <TextField
              {...field}
              label="Почта"
              variant="outlined"
              type="email"
              fullWidth
              error={!!errors.email}
              helperText={errors.email?.message}
              className={styles.input}
              InputProps={{
                style: {
                  borderRadius: 24,
                  color: "#fff",
                },
              }}
              InputLabelProps={{
                style: { color: "#ffffff83" },
              }}
              sx={textFieldStyles}
            />
          )}
        />

        <Typography className={styles.formDescription}>
          На указанный адрес мы отправим вам код подтверждения
        </Typography>

        <Button
          disabled={!isValid || isPending}
          type="submit"
          variant="contained"
          className={styles.button}
          sx={submitButtonStyles}
        >
          Получить код
        </Button>
      </form>
      <Button
        variant="text"
        onClick={() => navigate("/login")}
        sx={backButtonStyles}
      >
        Вернуться
      </Button>
    </>
  );
};
